/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type ProgressTour_tradeFirm = {
    readonly serviceId: string | null;
    readonly profileStatus: DesignProfileStatus | null;
    readonly publicProfile: {
        readonly about: string | null;
        readonly splashPhoto: string | null;
        readonly profilePhoto: string | null;
        readonly designProjectsCover: ReadonlyArray<{
            readonly status: string | null;
        } | null> | null;
        readonly address: {
            readonly zipCode: string | null;
            readonly country: string | null;
        } | null;
        readonly email: string | null;
        readonly portfolios: ReadonlyArray<{
            readonly serviceId: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ProgressTour_tradeFirm";
};
export type ProgressTour_tradeFirm$data = ProgressTour_tradeFirm;
export type ProgressTour_tradeFirm$key = {
    readonly " $data"?: ProgressTour_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProgressTour_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ProgressTour_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "profileStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "about",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "splashPhoto",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profilePhoto",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "designProjectsCover",
          "storageKey": null,
          "args": null,
          "concreteType": "DesignProjectCover",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "address",
          "storageKey": null,
          "args": null,
          "concreteType": "Address",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "zipCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "country",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "portfolios",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '3ca728a54f14a32400fbab3487ef50ca';
export default node;
